export enum ProjectContractStatus {
    Draft = 0,
    Active = 1,
    Suspended = 2,
    Terminated = 3,
    Expired = 4,
}
